import { InfoDialog } from './info-dialog';
import { DeviceMobileIcon } from '@phosphor-icons/react';

interface AppDownloadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  qrCodeUrl: string;
}

export function AppDownloadDialog({
  open,
  onOpenChange,
  qrCodeUrl
}: AppDownloadDialogProps) {
  return (
    <InfoDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Download App"
      description={`Scan to download the Lureo Beta App`}
      icon={<DeviceMobileIcon weight="duotone" className="h-12 w-12 text-lureo-ink-subtle" />}
      secondaryButton={{
        label: 'Close',
        onClick: () => onOpenChange(false),
        variant: 'outline-3'
      }}
    >
      <div className="flex flex-col items-center justify-center space-y-4">
        {/* QR Code */}
        <img
          src={qrCodeUrl}
          alt="App Download QR Code"
          className="w-64 h-64 rounded-lureo-radius-lg shadow-lureo-shadow-bar"
        />

        <p className="text-lureo-14 text-center text-lureo-ink-subtle leading-5">
          Scan this QR code with your device to download the Lureo Beta App
        </p>
      </div>
    </InfoDialog>
  );
}
